import { gql } from '@apollo/client'

export const GET_PRODUCT_FEATURES_FOR_SELECT = gql`
  query GET_PRODUCT_FEATURES_FOR_SELECT {
    findManyProductFeature {
      id
      photo {
        id
        src_xs
        src
      }
      product_containers {
        id
      }
      product_feature_profiles {
        id
        name
        language
      }
    }
  }
`

export const DELETE_MANY_PRODUCT_FEATURES = gql`
  mutation DELETE_PRODUCT_FEATURES($ids: [Int!]!) {
    deleteManyProductFeature(where: { id: { in: $ids } }) {
      count
    }
  }
`

export const GET_PRODUCT_FEATURES = gql`
  query GET_PRODUCT_FEATURES(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [ProductFeatureOrderByWithRelationInput!]
  ) {
    findManyProductFeature(
      where: {
        product_feature_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      code
      photo {
        id
        src_xs
        src
      }
      product_feature_profiles {
        id
        name
        description
        language
      }
      product_containers {
        id
        product_container {
          id
          reference
        }
      }
      createdAt
      updatedAt
    }
    findManyProductFeatureCount(
      where: {
        product_feature_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
    )
  }
`

export const GET_PRODUCT_FEATURE = gql`
  query GetProductFeature($id: Int!) {
    findUniqueProductFeature(where: { id: $id }) {
      id
      code
      photo {
        id
        src_xs
        src
      }
      product_feature_profiles {
        id
        name
        description
        language
      }
      product_containers {
        id
        product_container {
          id
          reference
        }
      }
    }
  }
`

export const CREATE_PRODUCT_FEATURE = gql`
  mutation CreateProductFeature($data: CreateProductFeatureWithProfilesInput!) {
    createProductFeature(data: $data) {
      id
      code
      product_feature_profiles {
        name
        description
        language
      }
      photo {
        src
        src_xs
        name
      }
    }
  }
`

export const UPDATE_PRODUCT_FEATURE = gql`
  mutation UpdateProductFeature(
    $where: ProductFeatureWhereUniqueInput!
    $data: UpdateProductFeatureWithProfilesInput!
  ) {
    updateProductFeature(where: $where, data: $data) {
      id
      code
      photo {
        id
        src
        name
      }
      product_feature_profiles {
        id
        language
        name
        description
      }
    }
  }
`

export const DELETE_PRODUCT_FEATURE = gql`
  mutation DeleteProductFeature($where: ProductFeatureWhereUniqueInput!) {
    deleteOneProductFeature(where: $where) {
      id
    }
  }
`

export const CHECK_FEATURE_USAGE = gql`
  query CheckFeatureUsage($featureId: Int!) {
    findUniqueProductFeature(where: { id: $featureId }) {
      id
      product_containers {
        id
        product_container {
          id
          reference
        }
      }
    }
  }
`
